module.exports = __webpack_public_path__ + "static/media/AA_logo.5b01c0a0.svg";